import React from 'react';

import filterTokens from '@amzn/meridian-tokens/base/icon/filter';
import Icon from '@amzn/meridian/icon';
import Tooltip from '@amzn/meridian/tooltip';

import './toggleFilterButton.scss';

const toggleFilterButton = (props: {
  onClick: () => void;
  tooltipTitle?: Tooltip['props']['title'];
  tooltipPlacement?: Tooltip['props']['position'];
  'data-testid'?: string;
}) => {
  const { tooltipTitle, tooltipPlacement, onClick, ['data-testid']: dataTestId } = props;

  // Initialize the button
  const button = (
    <div data-testid={dataTestId} className="hover-icon-wrapper" onClick={onClick}>
      <Icon tokens={filterTokens} />
    </div>
  );

  // If tooltip
  if (!tooltipTitle) {
    return button;
  }

  // If no tooltip
  return (
    <Tooltip position={tooltipPlacement ?? 'top'} title={tooltipTitle}>
      {button}
    </Tooltip>
  );
};

export default toggleFilterButton;
